import { apiATC, meekroDB } from '../config';

const BASE = `${apiATC}/client/liste.php`;

async function handleRes(res) {
  const data = await res.json();
  if (!res.ok) throw data;
  return data;
}

function normalize(r) {
  return {
    id:                   r.id ?? r.Num_agence,
    nom:                  r.nom ?? r.label ?? r.Nom_agence,
    id_parent:            r.Id_parent,
    id_groupe:            r.id_groupe,
    code_agence:          r.Code_Agence,
    adresse:              r.Rue,
    ville:                r.Ville,
    pays:                 r.Pays,
    cp:                   r.Code_postal,
    telephone:            r.Tel,
    fax:                  r.Fax,
    remise_n:             r.remiseN,
    remise_sp:            r.remiseSP,
    echeance_n:           r.echeanceN,
    echeance_sp:          r.echeanceSP,
    comptant:             r.comptant,
    id_tva:               r.id_tva,
    representant:         r.representant,
    code_ag:              r.code_ag,
    code_gu:              r.code_gu,
    compte:               r.compte,
    cle_rib:              r.cle_rib,
    observations:         r.observations,
    position:             r.position,
    affact:               r.affact,
    compte_quadra:        r.compte_quadra,
    compte_affacturage:   r.compte_affacturage,
    desc_pendentif:       r.desc_pendentif,
    rib_aff:              r.rib_aff,
    bic_aff:              r.bic_aff,
    coef:                 r.coef,
    logo:                 r.logo,
  };
}

export async function getClients() {
  const res = await fetch(BASE);
  const data = await res.json();
  if (!res.ok) throw data;
  return { success: true, data: data.map(normalize) };
}

export async function getTVAs() {
  const res = await fetch(`${meekroDB}/general.php?table=tva`);
  const data = await res.json();
  if (!res.ok) throw data;
  if (!Array.isArray(data)) throw new Error('Format de réponse TVA invalide');
  return data;
}

export async function getClient(id) {
  const res = await fetch(`${BASE}?id_bij=${id}`);
  const data = await res.json();
  if (!res.ok) throw data;
  const r = Array.isArray(data) && data[0] ? data[0] : data;
  return { success: true, data: normalize(r) };
}

export async function createClient(payload) {
  const res = await fetch(BASE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleRes(res);
}

export async function updateClient(id, payload) {
  const res = await fetch(`${BASE}?id=${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleRes(res);
}

export default { getClients, getTVAs, getClient, createClient, updateClient };
